var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "490.000000pt",
    height: "490.000000pt",
    viewBox: "0 0 490.000000 490.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.11, written by Peter Selinger 2001-2013\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,490.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2375 4813 c-550 -44 -1035 -271 -1399 -653 -507 -533 -700 -1272 -520 -1987 46 -185 106 -329 240 -584 197 -371 321 -696 389 -1014 10 -44 21 -87 26 -97 15 -29 239 -150 386 -209 204 -82 388 -135 594 -170 160 -27 551 -37 709 -17 l105 13 -1 35 c0 19 -6 93 -14 164 -14 145 -9 437 11 577 l12 87 88 -24 c289 -80 755 -142 982 -132 78 3 103 8 151 33 66 33 128 98 159 165 17 36 21 65 21 140 0 84 -3 101 -27 147 -15 28 -43 68 -63 87 -21 20 -35 38 -33 40 2 2 22 13 44 24 123 62 120 171 -6 227 -21 10 -39 21 -39 24 1 3 34 33 75 66 41 33 75 62 75 65 0 3 -34 32 -75 65 -41 33 -74 62 -75 65 0 3 75 39 166 80 126 56 164 77 161 89 -3 9 -104 238 -225 508 l-221 492 23 53 c68 156 91 278 83 459 -6 163 -29 254 -97 394 -86 178 -202 305 -395 434 -119 80 -324 184 -455 231 -264 95 -602 144 -855 123z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d6e83ca7174d032739f6dc8e8cd77117.svg";
export { ForwardRef as ReactComponent };